module.exports = __webpack_public_path__ + "static/img/7.3477dfb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg/7.jpg
// module id = H8mx
// module chunks = 1